export const PORTAL: 'combined' | 'internal' | 'vendor' =
  typeof __QCDOC_PORTAL__ === 'undefined' ? 'combined' : __QCDOC_PORTAL__;
export const IS_INDEPENDENT_PORTAL = PORTAL !== 'combined';
export const AUTH_PORTAL: 'QCDOC' | 'QCDOC-VENDOR' = PORTAL === 'vendor' ? 'QCDOC-VENDOR' : 'QCDOC';
export const LOGIN_PATH = PORTAL === 'vendor' ? '/vendor/login' : '/login';
export const HOME_PATH = PORTAL === 'vendor' ? '/vendor' : '/';

export function portalHref(path: string): string {
  return IS_INDEPENDENT_PORTAL ? `/#${path}` : path;
}

function baseUrl(value: string, setting: string): string {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value)
    || Array.from(value).some((character) => character.charCodeAt(0) <= 32
      || character.charCodeAt(0) === 127 || character === '\\')) {
    throw new Error(`Invalid ${setting}: expected an absolute HTTP(S) URL`);
  }
  const url = new URL(value);
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password
    || /^https?:\/\/[^/?#]*@/i.test(value)
    || url.pathname !== '/' || url.search || url.hash || value.includes('?') || value.includes('#')) {
    throw new Error(`Invalid ${setting}: expected an HTTP(S) site origin without credentials, path, query, or fragment`);
  }
  return url.href.replace(/\/$/, '');
}

const config = typeof window === 'undefined' ? undefined : window.__QCDOC_PORTAL_CONFIG__;
export const VENDOR_PORTAL_URL = config?.vendorPortalUrl === undefined
  ? undefined : baseUrl(config.vendorPortalUrl, 'vendorPortalUrl');
/** Origin of the internal portal; lets the vendor portal share mock data with it. */
export const INTERNAL_PORTAL_URL = config?.internalPortalUrl === undefined
  ? undefined : baseUrl(config.internalPortalUrl, 'internalPortalUrl');
/** The portal this one exchanges mock data with; undefined for the combined harness. */
export const PEER_PORTAL: 'internal' | 'vendor' | undefined = PORTAL === 'internal' ? 'vendor' : PORTAL === 'vendor' ? 'internal' : undefined;

/** Configured peer origin, or the conventional sibling dev-server port when both portals run on localhost. */
function resolvePeerPortalUrl(): string | undefined {
  if (!PEER_PORTAL) return undefined;
  const configured = PEER_PORTAL === 'vendor' ? VENDOR_PORTAL_URL : INTERNAL_PORTAL_URL;
  if (configured || typeof window === 'undefined') return configured;
  const { protocol, hostname, port } = window.location;
  if (!['localhost', '127.0.0.1'].includes(hostname) || port !== (PORTAL === 'internal' ? '5174' : '5175')) return undefined;
  return `${protocol}//${hostname}:${PEER_PORTAL === 'vendor' ? '5175' : '5174'}`;
}
export const PEER_PORTAL_URL = resolvePeerPortalUrl();
/** Azure Functions origin for the feedback API; unset keeps feedback in the browser-local mock. */
export const FEEDBACK_API_URL = config?.feedbackApiUrl === undefined
  ? undefined : baseUrl(config.feedbackApiUrl, 'feedbackApiUrl');